import { TransactionModel } from '~/types/model/transaction.model'
import type { ValueOf } from '~/types/value-of'
import { ITableColumnDef } from '~/ui/Table/tanstack/table.type'

export const TRANSACTION_TABLE_COLUMN: Array<ITableColumnDef<TransactionModel>> = [
  {
    id: 'transactionHash',
    accessorKey: 'transactionHash',
    header: 'Txn Hash',
    enableHiding: false,
  },
  {
    id: 'age',
    accessorKey: 'age',
    header: 'Age',
    meta: {
      toggle: {
        initialVisible: true,
        targetId: 'unixTimeStamp',
        tooltip: 'click to toggle timestamp'
      }
    }
  },
  {
    id: 'unixTimeStamp',
    accessorKey: 'unixTimeStamp',
    header: 'Datetime',
    meta: {
      toggle: {
        initialVisible: false,
        targetId: 'age',
        tooltip: 'click to toggle age'
      }
    }
  },
  {
    id: 'blockNumber',
    accessorKey: 'blockNumber',
    header: 'Block',
    enableHiding: false,
  },
  {
    id: 'method',
    accessorKey: 'method',
    header: 'Method',
    enableHiding: false,
  },
  {
    id: 'fromAddressInfo',
    accessorKey: 'fromAddressInfo',
    header: 'From',
    enableHiding: false,
  },
  {
    id: 'rightArrow',
    header: '',
    enableHiding: false,
  },
  {
    id: 'toAddressInfo',
    accessorKey: 'toAddressInfo',
    header: 'To',
    enableHiding: false,
  },

  {
    id: 'value',
    accessorKey: 'value',
    header: 'Value',
    enableHiding: false,
  },
  {
    id: 'transactionFee',
    accessorKey: 'transactionFee',
    header: 'Txn Fee',
    enableHiding: false,
  },
]

export const VIEW_TYPE = {
  DEFAULT: 'default',
  UTF8: 'utf-8',
  ORIGINAL: 'original'
} as const
export type ViewType = ValueOf<typeof VIEW_TYPE>


export const VIEW_TYPE_LIST = [
  {label: 'Default View', value: VIEW_TYPE.DEFAULT},
  {label: 'UTF-8', value: VIEW_TYPE.UTF8},
  {label: 'Original', value: VIEW_TYPE.ORIGINAL}
]
